'use client'

import { cn } from '@/lib/utils'
import { Typo3ReportsSnowreport } from '@/types'
import { Richtext } from '@/ui/components'
import { memo } from 'react'

const SnowreportTable = ({ ...data }: Typo3ReportsSnowreport) => (
  <>
    <div className={''}>
      {data.title && (
        <div className={cn('')}>
          <h3 className={cn('', 'h3')}>{data.title}</h3>
        </div>
      )}

      <div className={''}>
        {data?.rows?.map(
          (row: { label: string; value: string }, index: number) => (
            <div key={index?.toString()} className={cn('', '')}>
              <Richtext text={row.label} className={cn('')} />
              <Richtext text={row.value} className={cn('')} />
            </div>
          )
        )}
      </div>
    </div>
  </>
)

export default memo(SnowreportTable)
